import { Center, HStack, Spinner, Text } from "@chakra-ui/react";
import React from "react";

export const Loader = () => (
    <Center marginTop="20px">
        <HStack>
            <Spinner />
            <Text>Duke ngarkuar...</Text>
        </HStack>
    </Center>
);
